import React, { memo } from 'react';
import { useTranslate } from 'react-polyglot';

const EnableVR = memo(function EnableVR(props) {
    const t = useTranslate();
    const translationKey = props.data.isEnabled ? 'disableVR' : 'enableVR';

    return (
        <div>
            <p className='coa-dialog-msg'>{t(`experiences.${translationKey}.msg`)}</p>
            <p className='coa-dialog-msg-body'>{t(`experiences.${translationKey}.msgBody`)}</p>
        </div>
    )
})


export default EnableVR
